import React from "react";
import { motion } from "framer-motion";
import key_1 from "../assets/about.png";
import GlitchButton from "./GlitchButton";
import Header from "./Header";
import { Helmet } from "react-helmet-async";
import underscore_24X7 from "../assets/underscore24X7.png";
import underscore from "../assets/underscore1.png";

const Contact = () => {
  return (
    <div>
      <Helmet>
        <title>Contact Us | Get in Touch for Land Slot Game Services</title>
        <meta
          name="description"
          content="Have questions about our land slot game services? Contact us today for expert solutions in slot game development, management software, and casino integration."
        />
      </Helmet>

      <Header />

      {/* Animated Heading */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="bg-white pt-8 px-2   md:px-16 lg:px-56 text-center lg:text-start mx-auto"
      >
        <h1 className="md:text-[2.5rem] text-2xl text-center font-bold mb-4 md:mb-8 lg:text-start">
          Get in Touch with Fusion Spin
        </h1>
        <div className="pb-3 pl-7 lg:pl-0 hidden lg:block">
          <img src={underscore} alt="underscore" />
        </div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
          className="md:text-[18px] text-[14px] lg:text-base text-gray-500 text-left poppins-font2 leading-relaxed pb-8 px-8"
        >
          At Fusion Spin, we are dedicated to delivering exceptional land slot machine services that cater to your unique requirements. Whether you’re looking for more information about our products, need technical assistance, or wish to explore a partnership, our team is here to support you every step of the way.
        </motion.p>
        
        <h4 className="md:text-[2.5rem] text-2xl text-center font-bold mb-4 md:mb-8 lg:text-start">
          Why Reach Out to Us?
        </h4>

        <p className=" md:text-[18px] text-[14px] lg:text-base text-gray-500 text-left poppins-font2 leading-relaxed px-8">

          At Fusion Spin, we value strong partnerships and client relationships. Our focus on innovation and customer satisfaction ensures that we deliver reliable, cutting-edge solutions and ongoing support. Connect with us to explore how we can help elevate your gaming business.

        </p>
 
      </motion.section>

      {/* Animated Support Section */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
        className="bg-gray-100 lg:py-12 px-6 my-8  lg:px-24"
      >
        <div className="container mx-auto flex flex-col lg:flex-row gap-8 lg:gap-80">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
            className="lg:w-1/3"
          >

            <div className="md:my-6 ">
              <h3 className="text-2xl pt-8 md:pt-4 md:text-4xl font-extrabold py-4 lg:text-start text-center poppins-font">
                24/7 Support You Can Rely On
              </h3>
              <div className="pb-3 hidden lg:block">
                <img src={underscore_24X7} alt="underscore 24/7" />
              </div>
              <p className=" md:mb-6 mb-8 text-gray-500 text-left md:text-[1.2rem]  poppins-font2 text-sm/5 px-2 md:px-0 md:text-base/7">

                The gaming industry never takes a break—and neither do we! Our dedicated support team is available around the clock to ensure your land slot machines operate smoothly. Whether it's a minor query or a critical issue, we’re always just a message away.
              </p>
            </div>
            <div>
              <h3 className="text-2xl md:text-4xl font-extrabold py-4 lg:text-start text-center poppins-font">
                Remote Assistance for Instant Solutions
              </h3>
              <div className="pb-3 hidden lg:block">
                <img src={underscore} alt="underscore" />
              </div>
              <p className=" md:mb-6 mb-8 text-gray-500 text-left md:text-[1.2rem]  poppins-font2 text-sm/5 px-2 md:px-0 md:text-base/7">
                Facing a technical challenge? Our skilled team offers remote support to diagnose quickly and resolve issues with maximum efficiency. No matter your location, we ensure your land slot machines stay up and running without unnecessary downtime.
              </p>
            </div>
            <div>
              <h3 className="text-2xl md:text-4xl font-extrabold py-4 lg:text-start text-center poppins-font">
              Let's Connect
              </h3>
              <div className="pb-3 hidden lg:block">
                <img src={underscore} alt="underscore" />
              </div>
              <p className=" md:mb-6 mb-8 text-gray-500 text-left md:text-[1.2rem]  poppins-font2 text-sm/5 px-2 md:px-0 md:text-base/7">
              Partner with Fusion Spin to experience professional support and customized solutions for your gaming business. Connect with us today and discover how we can help transform your gaming business!
              </p>
            </div>
          </motion.div>

          {/* Contact Form with Slide-Up Animation */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="w-[100%] lg:w-[40%]"
          >
            <div className="bg-white rounded-lg lg:mt-12 shadow-md p-4 mb-8 md:mb-0 sm:p-8">
              <h3 className="lg:text-[2.5rem] text-3xl font-extrabold mb-4 text-[#FF5300] poppins-font">
                Contact Us
              </h3>
              <p className="text-gray-500 mb-6 text-sm lg:text-[18px] poppins-font2 text-start tracking-wider lg:leading-[1.9]">
                For further questions, please email hello@creative-tim.com or contact using our contact form.
              </p>

              <motion.form
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.8 }}
                className=""
              >
                <div className="flex justify-between md:flex-row  flex-col gap-3 poppins-font2">
                  <div className="mb-4 md::w-1/2 w-full">
                    <label
                      htmlFor="full-name"
                      className="block text-black font-bold mb-2 text-left"
                    >
                      Full Name
                    </label>
                    <input
                      type="text"
                      id="full-name"
                      name="full-name"
                      placeholder="Full Name"
                      defaultValue="John Doe"
                      required
                      className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-left placeholder:text-left bg-[#f3f3f3] text-[#797979]"
                    />
                  </div>
                  <div className="mb-4 poppins-font2 md::w-1/2 w-full">
                    <label
                      htmlFor="email"
                      className="block text-black font-bold mb-2 text-left"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Email-Id"
                      defaultValue="johndoe@example.com"
                      required
                      className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-left placeholder:text-left bg-[#f3f3f3] text-[#797979]"
                    />
                  </div>
                </div>
                <div className="mb-6 w-50">
                  <label
                    htmlFor="message"
                    className="block text-black font-bold mb-2 text-left"
                  >
                    How can we help you?
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    defaultValue="Describe your problem in at least 250 characters"
                    required
                    className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none text-left placeholder:text-left bg-[#f3f3f3] text-[#797979] shadow-none"
                  ></textarea>
                </div>

                {/* Animated Button */}
                <motion.div
                  initial={{ scale: 0.9 }}
                  animate={{ scale: 1 }}
                  whileHover={{ scale: 1.05 }}
                  className="flex items-center justify-center"
                >
                  <GlitchButton text="SEND MESSAGE" altText="GLITCH MODE" />
                </motion.div>
              </motion.form>
            </div>
          </motion.div>
        </div>
      </motion.section>
  
    </div>
  );
};

export default Contact;